import { createContext, useContext } from 'react';

import type { VideaNotesApiAdapter } from './adapter';

const VideaNotesApiContext = createContext<VideaNotesApiAdapter | null>(null);

export interface VideaNotesApiProviderProps {
  adapter: VideaNotesApiAdapter;
  children: React.ReactNode;
}

export function VideaNotesApiProvider({
  adapter,
  children,
}: VideaNotesApiProviderProps): React.ReactElement {
  return (
    <VideaNotesApiContext.Provider value={adapter}>
      {children}
    </VideaNotesApiContext.Provider>
  );
}

export function useVideaNotesApi(): VideaNotesApiAdapter {
  const adapter = useContext(VideaNotesApiContext);
  if (adapter == null) {
    throw new Error(
      'useVideaNotesApi must be used within a VideaNotesApiProvider',
    );
  }
  return adapter;
}
